import { useMemo } from 'react'

import { OurTeamRebrand as OurTeamRebrandSchema } from 'src/config/generated/sanitySchema'
import {
  TeamMemberQueryResult,
  TeamMemberType
} from 'src/server/router/sanity/groq/teamMembers/types'
import { trpc } from 'src/utils/trpc'

import { MemberSectionRebrand } from './MemberSectionRebrand'

const OurTeamRebrand = ({ heading, memberType }: OurTeamRebrandSchema) => {
  const { data, isLoading } = trpc.useQuery(['sanity.getTeamMembers'])
  const teamData = useMemo(() => {
    return data?.reduce((group, member) => {
      return {
        ...group,
        [member.memberType]: [...(group[member.memberType] || []), member]
      }
    }, {} as Record<TeamMemberType, TeamMemberQueryResult[]>)
  }, [data])

  if (!data || isLoading) return null

  return (
    <div className='container mx-auto px-4 lg:px-20'>
      <MemberSectionRebrand heading={heading} data={teamData?.[memberType]} />
    </div>
  )
}

export default OurTeamRebrand
